

//import clientAPI from "@/api/ClientAPIMixin.js";
//import Vue from "vue"

//Job sub-modules
import { JobUpdater } from "./JobUpdater"
import { JobCustomer } from "./JobCustomer"
import { JobParentjob } from "./JobParentjob"
import { JobSubjobs } from "./JobSubjobs"
import { JobPreview } from "./JobPreview"



export const JobHub = {
  namespaced: true,


  state: {

  },



  mutations: {

  },



  actions: {
    clearJob({ dispatch }) {
      //customer
      dispatch('JobHub/JobCustomer/setCustomer', null, { root: true });
      dispatch('JobHub/JobCustomer/setDeliveryAdress', null, { root: true })
      dispatch('JobHub/JobCustomer/setCustomerAdresses', [], { root: true })
      dispatch('JobHub/JobCustomer/setCustomerContacts', [], { root: true })
      //jobdetails
      dispatch('JobHub/JobParentjob/setJobDetails', null, { root: true })
      //subjobs
      dispatch('JobHub/JobSubjobs/clearSubjobs', null, { root: true })
    },
  },



  getters: {
    /**============================================
     *?ANCHOR               PREVIEW
     *=============================================**/
    PreviewCustomer: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobPreview/PreviewCustomer'];
    },
    PreviewMachine: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobPreview/PreviewMachine'];
    },

    /**============================================
     *?ANCHOR               CUSTOMER
     *=============================================**/
    CustomerAdresses: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobCustomer/CustomerAdresses'];
    },
    CustomerContacts: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobCustomer/CustomerContacts'];
    },

    Customer: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobCustomer/Customer'];
    },
    CustomerDeliveryAdress: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobCustomer/CustomerDeliveryAdress'];
    },
    CustomerContact: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobCustomer/CustomerContact'];
    },

    /**============================================
     *?ANCHOR               PARENTJOB
     *=============================================**/
    ParentJobName: (state, getters, rootState, rootGetters) => {
      var details = rootGetters['JobHub/JobParentjob/JobDetails']
      return details && details.DisplayName ? details.DisplayName : 'Job';
    },
    JobDetails: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/JobDetails'];
    },
    ParentOrder: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/Order'];
    },
    JobStatus: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/JobStatus'];
    },
    SaveableJob: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/SaveableJob'];
    },
    IsCompleteable: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/IsCompleteable'];
    },
    IsApproveable: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/IsApproveable'];
    },
    IsDeleteable: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/IsDeleteable'];
    },
    LoadingCreate: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobParentjob/LoadingCreate'];
    },

    /**============================================
     *?ANCHOR               SUBJOBS
     *=============================================**/
    Subjobs: (state, getters, rootState, rootGetters) => {
      return rootGetters['JobHub/JobSubjobs/Subjobs'];
    },
  },



  modules: { JobUpdater, JobCustomer, JobParentjob, JobSubjobs, JobPreview },


};
